import React from 'react';

class InputTextArea extends React.PureComponent {
    renderInput() {
        return (
            <div className="animated-placeholder">
                <textarea
                    id={this.props.id}
                    className={this.props.className}
                    maxLength={this.props.maxLength ? this.props.maxLength : null}
                    onChange={this.props.onChange}
                    value={this.props.value}
                    required={this.props.required}
                    onKeyPress={this.props.restrictCharacters ? this.props.restrictCharacters : null}
                />
                <label htmlFor={this.props.id}>{this.props.placeholder}{this.props.required ? <Required /> : null}</label>
            </div>
        );
    }

    render() {
        return (
            this.renderInput()
        );
    }
}

export default InputTextArea;